import gql from "graphql-tag";

export const GET_SUB_PAGE_INFO = gql`
  query archiveSubCategories($where: JSON) {
    archiveSubCategories(where: $where) {
      id
      title
      sub_title
      description
      featuring_image {
        url
      }
      material_images {
        images {
          mime
          url
        }
      }

      material_videos {
        title
        video_url
      }
    }
  }
`;

export const GET_MATERIAL_IMAGES_BY_SUB_CATEGORY_ID = gql`
  query materialImages($where: JSON) {
    materialImages(where: $where) {
      id
      images {
        url
      }
    }
  }
`;

export const GET_MATERIAL_VIDEO_BY_SUB_CATEGORY_ID = gql`
  query materialVideos($where: JSON) {
    materialVideos(where: $where) {
      id
      title
      video_url
      created_date
    }
  }
`;

export const GET_MATERIAL_FILE_BY_SUB_CATEGORY_ID = gql`
  query materialVideos($where: JSON) {
    materialFiles(where: $where) {
      id
      title
      file {
        name
        mime
        url
      }
    }
  }
`;
